import pinkBookFeeUpdateService from "@services/pinkBookFeeUpdate/pinkBookFeeUpdateService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import { action, makeAutoObservable, observable } from "mobx"

class PinkBookFeeUpdateStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable contractOverviewData!: PagedResultDto<any>
  @observable editingRecord: any = null

  constructor() {
    makeAutoObservable(this)

    this.isLoading = false
    this.tableData = { items: [], totalCount: 0 }
    this.contractOverviewData = { items: [], totalCount: 0 }
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await pinkBookFeeUpdateService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  @action
  async getAllContractOverview(params: any) {
    this.isLoading = true
    const result = await pinkBookFeeUpdateService
      .getAllContractOverview(params)
      .finally(() => (this.isLoading = false))
    this.contractOverviewData = result
  }

  @action
  setEditingRecord(record: any) {
    this.editingRecord = record
  }
}

export default PinkBookFeeUpdateStore
